import {
  AnalyticsComponent,
  AnalyticsFieldName,
  OnboardingV2AnalyticsEvent,
  OnboardingV2AnalyticsPageView,
} from "@/constants/analytics/Analytics";
import { ModalPath } from "@/constants/Navigation";
import { OrderedOnboardingSteps } from "@/constants/Onboarding";
import { router } from "@/crossPlatform/expo-router";
import { useAnalytics } from "@/services/Analytics";
import { useAppSelector } from "@/store/hooks";
import { selectOnboardingCurrentStepIndex } from "@/store/reducers/onboarding";
import { OnboardingOverviewCard } from "@/ui/components/onboarding/v2/cards/OnboardingOverviewCard";
import { getOnboardingStepContent } from "@/ui/components/onboarding/v2/content/OnboardingStepContent";

const OnboardingOverviewSection = () => {
  const { track } = useAnalytics();
  const currentStepIndex = useAppSelector(selectOnboardingCurrentStepIndex);

  const currentStepName =
    OrderedOnboardingSteps[currentStepIndex] ?? OrderedOnboardingSteps[0];
  const { title: currentStepLabel } = getOnboardingStepContent({
    stepName: currentStepName,
  });

  const handleContinuePress = () => {
    track(OnboardingV2AnalyticsEvent.ContinuePressed, {
      [AnalyticsFieldName.Component]: AnalyticsComponent.Button,
      [AnalyticsFieldName.Source]: OnboardingV2AnalyticsPageView.Overview,
    });

    router.push(`/${ModalPath.OnboardingV2}`);
  };

  return (
    <OnboardingOverviewCard
      currentStepIndex={currentStepIndex}
      currentStepLabel={currentStepLabel}
      onContinuePress={handleContinuePress}
    />
  );
};

export { OnboardingOverviewSection };
